import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from "@angular/router";

export class RouteReuser extends BaseRouteReuseStrategy{
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return false;
    }
}